module.exports = __webpack_public_path__ + "static/media/sair.06423c7a.svg";